export default __webpack_public_path__ + "images/IZ.38293b5.png";